<div class="component">
  @if (totp) {
    <div class="totp-container">
      @if (viewQr) {
        <button class="text-button" (click)="viewQr=false">
          <mat-icon>swap_horiz</mat-icon> <span trans="totp_code.view_secret"></span>
        </button>
        <div class="code">
          <a [href]="safeAuthUrl">
            <nom-qrcode [data]="totp.authUrl"></nom-qrcode>
          </a>
        </div>
      }
      @if (!viewQr) {
        <button class="text-button" (click)="viewQr=true">
          <mat-icon>swap_horiz</mat-icon> <span trans="totp_code.view_qr"></span>
        </button>
        <div class="code">
          <div class="splits">
            @for (part of otpParts; track part) {
              <span>{{part}}</span>
            }
          </div>
        </div>
        @if (!copied) {
          <button
            class="text-button"
            trans="totp_code.copy_secret"
            (click)="copySecret()"
            (keyPress)="copySecret()"
          ></button>
        }
        @if (copied) {
          <button
            class="text-button"
            trans="totp_code.copied_secret"
          ></button>
        }
      }
    </div>
  }

  <div>
    <p trans="totp_code.p1"></p>
    <p trans="totp_code.p2"></p>
  </div>
</div>
